import DatePick from 'components/DatePicker'
import React, { useContext, useState } from 'react'
import { AddressChangeContext } from '../AddressContext/AddressChangeContext'
import { NewAddressContext } from '../AddressContext/NewAddressContext'
import DateField from '../CustomInputs/DateField/DateField'
import AddressField from '../CustomInputs/AddressField/AddressField'
import { RadioButtonField } from '../CustomInputs/RadioButtonField/RadioButtonField'
import AddressGaraged_Questions from '../CustomInputs/AddressGaraged/AddressGaraged_Questions'

const NewAddress = () => {
    const addressChangeContext = useContext(AddressChangeContext)
    const newAddressContext = useContext(NewAddressContext)
    const [dateMoved, setDateMoved] = useState(addressChangeContext.getTodaysDate())
    const [requestedEffDate, setRequestedEffDate] = useState(addressChangeContext.getTodaysDate(true))

    return (
        <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
            {/* Date Moved */}
            <DateField
                label="Date of Move"
                dateSubmit={newAddressContext?.newAddress?.dateMoved ? newAddressContext?.newAddress?.dateMoved : dateMoved}
                setDateSubmit={setDateMoved}
                storeValue={newAddressContext?.newAddressCallback}
                nameValue="dateMoved"
                set30Days={true}
            />

            {/* Requested Effective Date */}
            <DateField
                label="Requested Effective Date"
                dateSubmit={newAddressContext?.newAddress?.requestedEffDate ? newAddressContext?.newAddress?.requestedEffDate : requestedEffDate}
                setDateSubmit={setRequestedEffDate}
                storeValue={newAddressContext?.newAddressCallback}
                nameValue="requestedEffDate"
            />

            <h5 className='text-primary text-center fw-bold mb-4'>New Address</h5>

            {/* Address and Apartment Number Fields */}
            <AddressField
                label1="homeAddress"
                name1="Address"
                value1={newAddressContext?.newAddress?.homeAddress}
                placeholder1="Home Address *"
                label2="aptNumber"
                name2="ApartmentNum"
                value2={newAddressContext?.newAddress?.aptNumber}
                placeholder2="Apt #"
                setCallback={newAddressContext?.newAddressCallback}
                householdAddress={true}
            />

            {/* City and Zip Fields */}
            <AddressField
                label1="city"
                name1="City"
                value1={newAddressContext?.newAddress?.city}
                placeholder1="City *"
                label2="zip"
                name2="Zip"
                value2={newAddressContext?.newAddress?.zip}
                placeholder2="Zip *"
                setCallback={newAddressContext?.newAddressCallback}
                householdAddress={true}
            />

            {/* Garaged Overnight At New Address */}
            <RadioButtonField
                name="garaged"
                question={"Will all vehicles on the policy be garaged at this new address overnight?*"}
                value={newAddressContext?.newAddress?.garaged ? newAddressContext?.newAddress?.garaged : ""}
                setCallback={newAddressContext?.newAddressCallback}
            />

            {/* Vehicles Garaged Elsewhere */}
            <AddressGaraged_Questions
                context={addressChangeContext}
                newAddressContext={newAddressContext}
            />
        </div>
    )
}

export default NewAddress